/* assets/z__minicart.js */
(() => {
  "use strict";

  const safeDefine = (name, ctor) => {
    if (customElements.get(name)) return;
    customElements.define(name, ctor);
  };

  const lockScroll = () => {
    const y = window.scrollY || window.pageYOffset || 0;
    document.body.dataset.scrollY = String(y);
    document.body.style.top = `-${y}px`;
    document.body.classList.add("overflow-hidden-fixed");
  };

  const unlockScroll = () => {
    const y = parseInt(document.body.dataset.scrollY || "0", 10);
    document.body.style.top = "";
    document.body.classList.remove("overflow-hidden-fixed");
    window.scrollTo({ top: y, left: 0, behavior: "instant" });
    delete document.body.dataset.scrollY;
  };

  const ROOT =
    window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : "/";

  async function fetchSectionHTML(sectionId) {
    const url = new URL(ROOT, window.location.origin);
    url.searchParams.set("section_id", sectionId);
    const res = await fetch(url.toString(), { credentials: "same-origin" });
    if (!res.ok) throw new Error(`section fetch failed: ${res.status}`);
    return await res.text();
  }

  async function fetchCartJSON() {
    const res = await fetch(`${ROOT}cart.js`, { credentials: "same-origin" });
    if (!res.ok) throw new Error(`cart.js failed: ${res.status}`);
    return await res.json();
  }

  function updateBubble(count) {
    document.querySelectorAll(".cart-bubble").forEach((el) => {
      el.textContent = String(count || 0);
      if ((count || 0) === 0) el.classList.add("hide");
      else el.classList.remove("hide");
    });
  }

  function extractMinicartInnerHTMLFromSectionHTML(html) {
    const doc = new DOMParser().parseFromString(html, "text/html");

    // Ce qu'on veut absolument : le "vrai" HTML Phantom du minicart
    // (dans ta section il est dans <div class="minicart-section" ...> ... </div>)
    const src = doc.querySelector(".minicart-section");

    if (src) return src.innerHTML;

    // Fallback: si jamais ça change, on tente la section Shopify
    const shopifySection = doc.querySelector("#shopify-section-minicart");
    if (shopifySection) return shopifySection.innerHTML;

    // Dernier fallback
    return doc.body ? doc.body.innerHTML : html;
  }

  class MiniCart extends HTMLElement {
    connectedCallback() {
      this.details = this.closest("details");
      this.content = this.querySelector(".minicart-content");

      // IMPORTANT : id de ta section Shopify
      this.sectionId = "minicart";

      this.bindEvents();
      this.refresh(); // premier rendu

      // resize
      window.addEventListener(
        "resize",
        (this._onResize = () => {
          if (document.documentElement.clientWidth > 500) this.refresh();
        })
      );

      // ESC
      document.addEventListener(
        "keydown",
        (this._onKey = (e) => {
          if (e.key === "Escape") this.close();
        })
      );

      // click overlay => close
      document.addEventListener(
        "click",
        (this._onDocClick = (e) => {
          if (!this.isOpen()) return;
          if (e.target.closest("#bud-mini-cart-details .minicart-content")) return;
          if (e.target.closest("#bud-mini-cart-details > summary")) return;
          this.close();
        })
      );

      // Patch fetch : si un script fait /cart/add.js, /cart/change.js, /cart/update.js => on refresh
      if (!window.__BUD_MINICART_FETCH_PATCHED__) {
        window.__BUD_MINICART_FETCH_PATCHED__ = true;

        const origFetch = window.fetch.bind(window);
        window.fetch = async (...args) => {
          const resp = await origFetch(...args);
          try {
            const url = String(args[0] || "");
            if (
              url.includes("/cart/add") ||
              url.includes("/cart/change") ||
              url.includes("/cart/update") ||
              url.includes("/cart/clear")
            ) {
              setTimeout(() => {
                document
                  .querySelectorAll("mini-cart#bud-mini-cart")
                  .forEach((mc) => mc.refresh());
              }, 80);
            }
          } catch (_) {}
          return resp;
        };
      }
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this._onResize);
      document.removeEventListener("keydown", this._onKey);
      document.removeEventListener("click", this._onDocClick);
    }

    isOpen() {
      return !!this.details?.hasAttribute("open");
    }

    async refresh() {
      if (!this.content) return;

      try {
        // 1) Récupère le HTML Shopify de la section
        const html = await fetchSectionHTML(this.sectionId);

        // 2) Injecte UNIQUEMENT le contenu Phantom (la div .minicart-section)
        this.content.innerHTML = extractMinicartInnerHTMLFromSectionHTML(html);

        // 3) Bubble count fiable
        const cart = await fetchCartJSON();
        updateBubble(cart.item_count);

        // 4) Rebind close buttons
        this.content
          .querySelectorAll(".modal__close,[data-minicart-close]")
          .forEach((btn) => {
            if (btn.__budBound) return;
            btn.__budBound = true;
            btn.addEventListener("click", (e) => {
              e.preventDefault();
              this.close();
            });
          });
      } catch (e) {
        console.warn("[mini-cart] refresh failed", e);
      }
    }

    bindEvents() {
      if (!this.details) return;

      const summary = this.details.querySelector("summary");
      if (summary && !summary.__budBound) {
        summary.__budBound = true;
        summary.addEventListener("click", async (e) => {
          e.preventDefault();
          if (this.isOpen()) this.close();
          else {
            this.open();
            await this.refresh();
          }
        });
      }

      if (!this.details.__budToggleBound) {
        this.details.__budToggleBound = true;
        this.details.addEventListener("toggle", () => {
          if (this.isOpen()) lockScroll();
          else unlockScroll();
        });
      }
    }

    open() {
      if (!this.details) return;
      this.details.setAttribute("open", "");
    }

    close() {
      if (!this.details) return;
      this.details.removeAttribute("open");
    }
  }

  safeDefine("mini-cart", MiniCart);
})();
